<template>
  <div class="sensor-settings">
    <div>
      <div class="header">
        <div class="title">
          <ul>
            <li id="title-icon">
              <div></div>
              <span>通知設定</span>
            </li>
          </ul>
        </div>
      </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <!-- <div class="sub-title">水位設定</div> -->
          <dl class="columns">
            <dt>
              <div>
                <span>警告水位(cm)</span>
                <img src="@/assets/water/water02.png" style="height:30px; margin: 0 10px;"/>
              </div>
            </dt>
            <dd>
              <ValidationProvider
                rules="customDoubleWater"
                immediate
                name="warn_value"
                v-slot="ProviderProps"
              >
                <input
                  type="text"
                  placeholder="例) 3"
                  v-model="settings.warn_value"
                  style="max-width: 50%; margin: 0 20px 0 0"
                />
                <select
                  name="text"
                  v-model="settings.warn_unit"
                >
                  <option
                    v-for="(row, index) in warnRanges"
                    :key="index"
                    :value="index"
                  >
                    {{ row }}
                  </option>
                </select>
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>
              <div>
                <span>危険水位(cm)</span>
                <img src="@/assets/water/water03.png" style="height:30px; margin: 0 10px;"/>
              </div>
            </dt>
            <dd>
              <ValidationProvider
                rules="customDoubleWater"
                immediate
                name="caution_value"
                v-slot="ProviderProps"
              >
                <input
                  type="text"
                  placeholder="例) 5"
                  v-model="settings.caution_value"
                  style="max-width: 50%; margin: 0 20px 0 0"
                />
                <select
                  name="text"
                  v-model="settings.caution_unit"
                >
                  <option
                    v-for="(row, index) in cautionRanges"
                    :key="index"
                    :value="index"
                  >
                    {{ row }}
                  </option>
                </select>
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <!-- <div class="sub-title">通知設定</div> -->
          <dl class="columns">
            <dt>通知有無</dt>
            <dd>
              <div>
                <input id="box1" type="checkbox" v-model="settings.notify"/>
                <label for="box1">スマートフォンアプリに通知する</label>
              </div>
              <span style="font-size:14px">※1時間おきに水位センサーのデータを判定し通知を行います。</span>
            </dd>
          </dl>
          <!-- <dl class="columns">
            <dt>通知時刻</dt>
            <dd>
              <input
                id="box_alltime"
                type="checkbox"
              />
              <label for="box_alltime">毎時通知</label>
              <div class="repeat" for="box_alltime">
                <div v-for="h in hours" :key="h">
                  <input
                    :id="`box_${h}h`"
                    type="checkbox"
                    :value="h"
                  />
                  <label :for="`box_${h}h`">{{ h }}時</label>
                </div>
              </div>
            </dd>
          </dl> -->
        </div>
      </div>
      <span
        class="btn-submit"
        :class="{ disable: ObserverProps.invalid }"
        @click="update"
        >保存</span
      >
    </validation-observer>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";

const SETTIG_ID_WATER = "water"; 

export default {
  mixins: [Loader],

  data() {
    return {
      warnRanges: ["以上", "以下"],
      cautionRanges: ["以上", "以下"],
      settings: {
        warn_value: null,
        caution_value: null,
        warn_unit: 0,
        caution_unit: 0,
        notify: false,
      },
    };
  },

  computed: {
    // hours() {
    //   let hours = [];
    //   for (let i = 0; i < 24; i++) {
    //     hours.push(i);
    //   }
    //   return hours;
    // },
  },
  
  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.show();
    });
  },

  methods: {
    ...mapActions(["retrieveSettings", "updateSettings"]),

    async show() {
      try {
        const ret = await this.retrieveSettings(SETTIG_ID_WATER);
        if (!ret.settings) {
          return;
        }

        this.settings = ret.settings;

      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const params = {
        id: SETTIG_ID_WATER,
        settings: {
          warn_value: this.settings.warn_value,
          warn_unit: this.settings.warn_unit,
          caution_value: this.settings.caution_value,
          caution_unit: this.settings.caution_unit,
          notify: this.settings.notify,
        },
      };
      try {
        await this.updateSettings(params);
        this.$router.push({ name: "water-show" });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" src="">
.sensor-settings {
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      .sub-title {
        font-size: 18px;
        margin: 10px 0;
      }

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      .repeat {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      }
      input[type="checkbox"]:checked ~ .repeat {
        display: none;
      }


      input[type="text"],
      input[type="date"],
      input[type="number"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus,
      input[type="number"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_notifications_menu.svg") no-repeat center
      center;
  }
}
</style>
